import { PendingInvitationFilterModel } from './PendingInvitationsFilter'

export const defaultPendingInvitationsFilter: PendingInvitationFilterModel = {
  emailPattern: null,
  namePattern: null,
  roleGroups: [],
  status: null,
  invitationDate: null,
}
